import React from "react";
import { EmptyTabletCol } from "../../components/commons/Commons.style";
import ContentRichText from "../../components/contentRichText";
import { Col, Grid } from "../../components/grid";
import SectionWrapper from "../../components/sectionWrapper";

import IRichText from "../../models/IRichText";

interface IRichTextContent {
  content: IRichText;
}

const RichTextContent = ({ content }: IRichTextContent) => {
  return (
    <SectionWrapper>
      <Grid cols={12} columnGap={16} rowGap={0}>
        <EmptyTabletCol />
        <Col xxl={12} md={10} sm={12}>
          <ContentRichText content={content} />
        </Col>
        <EmptyTabletCol />
      </Grid>
    </SectionWrapper>
  );
};

export default RichTextContent;
